import {createSidebarUI, SidebarUI} from './sidebarUI';
import {INewsletterPopupData} from './model';
import axios from "axios";

export class sidebar {

    private url: string = window.ajaxurlnl;

    public constructor(private ui: SidebarUI) {
        this.ui.fillHiddenFields();
        this.ui.clickTopButton(this.scrollToTop.bind(this))
        this.ui.clickPhoneButton(this.showContentPhone.bind(this))
        this.ui.clickEventClose(this.closeContentEvent.bind(this))
        this.ui.clickEventButton(this.showContentEvent.bind(this))
        this.ui.clickPhoneClose(this.closeContentPhone.bind(this))
        this.ui.clickNewsletterButton(this.showContentNewsletter.bind(this))
        this.ui.clickNewsletterClose(this.closeContentNewsletter.bind(this))
        this.ui.onSubmit(this.doSubmit.bind(this));

        if (document.body.classList.contains('home')){
            var executed = false;
            window.addEventListener("scroll", () => {
                if (document.documentElement.scrollTop >= 1000) {
                    if(!executed) {
                        executed = true;
                        this.showContentEvent();
                    }
                }
            });
          }

          if (document.body.classList.contains('single-post')){
            var executed = false;
            const breakpoint = document.querySelector('.content__blog') as HTMLElement
            const OPEN_BREAKPOINT: number = breakpoint.offsetHeight / 4 + 220;
            window.addEventListener("scroll", () => {
                if (document.documentElement.scrollTop >= OPEN_BREAKPOINT) {
                    if(!executed) {
                        executed = true;
                        this.showContentNewsletter();
                    }
                }
            });
          }


        if (this.readCookie()=== true) {
            this.ui.allowShow = false;
        }
    }

    //Top JS

    public scrollToTop() {
        this.ui.smoothScroll();
    }

    //Phone JS

    public showContentPhone() {
        this.ui.showContentPhone();
    }

    public closeContentPhone() {
        this.ui.closeContentPhone();
    }

    //Event JS

    public showContentEvent() {
        this.ui.showContentEvent();
    }

    public closeContentEvent() {
        this.ui.closeContentEvent();
    }

    //Newsletter JS

    public showContentNewsletter() {
        this.ui.showContentNewsletter();
    }

    public closeContentNewsletter() {
        this.ui.closeContentNewsletter();
    }

     public writeCookie() {
        document.cookie = "allowNewsletterPopup=false";
    }

    public readCookie() {
        if (document.cookie.split(';').filter((item) => item.includes('allowNewsletterPopup=false')).length) {
            return true;
        }
        return false;
    }

    public doSubmit(data: INewsletterPopupData) {
        axios.get(this.url, {
          params: data
        }).then(() => {
            this.ui.onSuccess();
        }).catch((error) => {
            this.ui.onError(error);
        });
    }
}


export function initSidebar() {
    const uiInstance = createSidebarUI();
    const instance = uiInstance.map((uiInstance: SidebarUI) => {
        return new sidebar(uiInstance);
    });
}
